module.exports = __webpack_public_path__ + "static/media/Gotham-BlackItalic.3a3941f8.ttf";